<template>
  <div>
    <TopBarTitleComponent title="Negocio" :showBackIcon="true">
      <template slot="right-area">
        <div
          class="d-flex justify-content-end align-items-center"
          style="gap: 10px;"
        >
          <ButtonDeleteComponent
            @onConfirmDelete="onConfirmDelete"
            v-if="actionForm == 'editar'"
          />
          <ButtonPrimaryComponent
            title="Guardar cambios"
            @onSaveClick="handleSaveCurrentTab"
          />
        </div>
      </template>
    </TopBarTitleComponent>
    <section class="">
      <b-container fluid>
        <MessageComponent
          :show="businessStart"
          title="¡Has creado un nuevo negocio!"
          subtitle="Configura tu nueva cuenta de negocio y empieza a administrarlo ¡ahora!"
          btnTitle="Comenzar"
          :routePage="{
            path: 'negocio',
            query: { action: 'nuevo' }
          }"
        />
        <b-row>
          <b-col sm="12" md="12" lg="12">
            <div class="box-shadow border-radius p-3 mb-3 bg-color-write">
              <el-tabs v-model="activeTabName">
                <el-tab-pane
                  label="Perfil de empresa"
                  name="business"
                  class="p-4"
                >
                  <div class="bg-color-write" v-if="user.user_business">
                    <b-row>
                      <b-col sm="12" md="12" lg="12">
                        <div
                          class="image"
                          :style="[
                            user.user_business.business_logo
                              ? styleProfileImage
                              : ''
                          ]"
                        >
                          <FileUploadComponent
                            title="Selecciona logo empresa"
                            @fileBase64="file => onFileBase64BusinessLogo(file)"
                            :preview="business_logo"
                            :showFileList="false"
                            className="image-profile mt-4"
                          />
                        </div>
                      </b-col>
                    </b-row>
                    <h4 class="h4 font-semi-bold mt-5 mb-4">
                      Datos de la empresa
                    </h4>
                    <el-form
                      :model="user.user_business"
                      :rules="rules"
                      ref="businessForm"
                    >
                      <!-- Razón Social — full width -->
                      <b-row>
                        <b-col sm="12">
                          <label class="font-semi-bold m-0">Razón Social</label>
                          <el-form-item prop="social_reason" class="mb-4">
                            <input
                              class="form-control input-profile"
                              v-model="user.user_business.social_reason"
                            />
                          </el-form-item>
                          <el-form-item
                            prop="business_id"
                            class="mb-0"
                            style="display:none;"
                          >
                            <input
                              type="hidden"
                              v-model="user.user_business.id"
                            />
                          </el-form-item>
                        </b-col>
                      </b-row>

                      <!-- Nombre Comercial + RUC -->
                      <b-row>
                        <b-col sm="12" md="6">
                          <label class="font-semi-bold m-0"
                            >Nombre Comercial</label
                          >
                          <el-form-item prop="business_name" class="mb-4">
                            <input
                              class="form-control input-profile"
                              v-model="user.user_business.business_name"
                            />
                          </el-form-item>
                        </b-col>
                        <b-col sm="12" md="6">
                          <label class="font-semi-bold m-0">RUC</label>
                          <el-form-item prop="business_ruc" class="mb-4">
                            <input
                              class="form-control input-profile"
                              v-model="user.user_business.business_ruc"
                            />
                          </el-form-item>
                        </b-col>
                      </b-row>

                      <!-- Correo + Teléfono -->
                      <b-row>
                        <b-col sm="12" md="6">
                          <label class="font-semi-bold m-0">Correo</label>
                          <el-form-item prop="business_email" class="mb-4">
                            <input
                              class="form-control input-profile"
                              v-model="user.user_business.business_email"
                            />
                          </el-form-item>
                        </b-col>
                        <b-col sm="12" md="6">
                          <label class="font-semi-bold m-0">Teléfono</label>
                          <input
                            type="text"
                            class="form-control input-profile mb-4"
                            v-model="user.user_business.business_phone"
                          />
                        </b-col>
                      </b-row>

                      <!-- Categoría + Cantidad personas -->
                      <b-row>
                        <b-col sm="12" md="6">
                          <label class="font-semi-bold m-0">Categoría</label>
                          <el-form-item prop="category_id" class="mb-4">
                            <el-select
                              placeholder="Seleccionar"
                              class="el-info-profile"
                              v-model="user.user_business.category_id"
                            >
                              <el-option
                                v-for="category in categories"
                                :key="category.id"
                                :label="category.name"
                                v-model="category.id"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                        <b-col sm="12" md="6">
                          <label class="font-semi-bold m-0"
                            >Cantidad personas</label
                          >
                          <el-form-item prop="people_number" class="mb-4">
                            <el-select
                              class="el-info-profile"
                              placeholder="Seleccionar"
                              v-model="user.user_business.people_number"
                            >
                              <el-option
                                v-for="pn in peopleNumbers"
                                :key="pn.value"
                                :label="pn.label"
                                v-model="pn.value"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="12" md="6">
                          <label class="font-semi-bold m-0">Dirección</label>
                          <el-form-item prop="business_address" class="mb-4">
                            <input
                              class="form-control input-profile"
                              v-model="user.user_business.business_address"
                            />
                          </el-form-item>
                        </b-col>
                        <b-col sm="12" md="6">
                          <label class="font-semi-bold m-0">Ciudad</label>
                          <el-select
                            filterable
                            placeholder="Seleccionar"
                            class="el-info-profile mb-4"
                            v-model="user.user_business.city_id"
                          >
                            <el-option
                              v-for="city in cities"
                              :key="city.id"
                              :label="city.name"
                              v-model="city.id"
                            ></el-option>
                          </el-select>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="12" md="6">
                          <label class="font-semi-bold m-0">País</label>
                          <el-select
                            filterable
                            placeholder="Seleccionar país"
                            class="el-info-profile mb-4"
                            v-model="user.user_business.country_code"
                          >
                            <el-option
                              v-for="country in countries"
                              :key="country.code"
                              :label="country.name"
                              :value="country.code"
                            ></el-option>
                          </el-select>
                          <small
                            class="text-muted d-block"
                            style="margin-top:-12px; margin-bottom:12px;"
                          >
                            Define el país para aplicar validaciones locales en
                            documentos de empresas y transportistas.
                          </small>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="12" md="6" lg="6" class="mb-4">
                          <h4 class="h4 my-3">Perfil tributario</h4>
                        </b-col>
                      </b-row>
                      <b-row class="mb-4">
                        <b-col sm="12" md="6" lg="6">
                          <div class="">
                            <el-form-item
                              ><el-checkbox
                                class="d-block"
                                v-model="
                                  user.user_business.accounting_obligation
                                "
                                >Obligación de contabilidad
                              </el-checkbox></el-form-item
                            >
                          </div>

                          <div class="">
                            <el-form-item
                              ><el-checkbox
                                class="d-block"
                                v-model="
                                  user.user_business.microenterprise_obligation
                                "
                                >Contribuyente Régimen RIMPE</el-checkbox
                              ></el-form-item
                            >
                          </div>
                          <div class="">
                            <el-form-item
                              ><el-checkbox
                                class="d-block"
                                v-model="
                                  user.user_business.popular_business_obligation
                                "
                                >Contribuyente Negocio Popular - Régimen
                                RIMPE</el-checkbox
                              ></el-form-item
                            >
                          </div>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="12" md="6" lg="6">
                          <label class="font-semi-bold m-0"
                            >Contribuyente Especial</label
                          >
                          <el-form-item
                            prop="special_taxpayer_number"
                            class="mb-4"
                          >
                            <input
                              class="form-control input-profile mb-3"
                              maxlength="3"
                              v-model="
                                user.user_business.special_taxpayer_number
                              "
                              placeholder=""
                            />
                          </el-form-item>
                        </b-col>
                      </b-row>
                    </el-form>
                  </div>
                </el-tab-pane>
                <el-tab-pane
                  label="Facturación Electrónica"
                  name="signature"
                  class="p-4"
                  v-if="actionForm == 'editar'"
                >
                  <b-row class="mt-3">
                    <b-col xs="12" sm="3" md="3" lg="3">
                      <nav class="sig-nav">
                        <a
                          class="sig-nav-item"
                          :class="{
                            active: activeTabsSignature === 'configSignature'
                          }"
                          @click="activeTabsSignature = 'configSignature'"
                        >
                          <i class="el-icon-edit-outline sig-nav-item-icon"></i>
                          <span>Configuración de Firma</span>
                        </a>
                        <a
                          class="sig-nav-item"
                          :class="{
                            active: activeTabsSignature === 'configGeneral'
                          }"
                          @click="activeTabsSignature = 'configGeneral'"
                        >
                          <i class="el-icon-setting sig-nav-item-icon"></i>
                          <span>Configuración General</span>
                        </a>
                      </nav>
                    </b-col>
                    <b-col xs="12" sm="9" md="9" lg="9">
                      <SignatureAddComponent
                        v-if="activeTabsSignature === 'configSignature'"
                      />
                      <DocumentSequenceAddComponent
                        v-if="activeTabsSignature === 'configGeneral'"
                        class="mt-2"
                      />
                    </b-col>
                  </b-row>
                </el-tab-pane>
                <el-tab-pane
                  label="Establecimientos"
                  name="stablishment"
                  class="p-4"
                  v-if="actionForm == 'editar'"
                >
                  <TransitionFadeComponent>
                    <BusinessStablishmentListComponent
                      v-if="!toogleStablishment"
                      @onStablishmentView="onStablishmentView"
                    />

                    <BusinessStablishmentViewComponent
                      v-else
                      :stablishment="establishmentSelected"
                      @onStablishmentListBack="onStablishmentView"
                    />
                  </TransitionFadeComponent>
                </el-tab-pane>

                <el-tab-pane
                  label="Integraciones"
                  name="integrations"
                  class="p-4"
                  v-if="actionForm == 'editar'"
                >
                  <!-- Card grid cuando no hay integración seleccionada -->
                  <div v-if="!activeIntegration" class="integ-grid">
                    <div
                      v-for="integ in integrationsList"
                      :key="integ.key"
                      class="integ-card"
                      @click="activeIntegration = integ.key"
                    >
                      <div
                        class="integ-card-icon"
                        :style="{ background: integ.bg }"
                      >
                        <i
                          :class="integ.icon"
                          :style="{ color: integ.color }"
                        ></i>
                      </div>
                      <div class="integ-card-info">
                        <span class="integ-card-name">{{ integ.name }}</span>
                        <span class="integ-card-desc">{{ integ.desc }}</span>
                      </div>
                      <i class="el-icon-arrow-right integ-card-arrow"></i>
                    </div>
                  </div>

                  <!-- Vista interna de cada integración -->
                  <div v-else>
                    <div class="integ-view-header">
                      <button
                        class="integ-back-btn"
                        @click="activeIntegration = null"
                      >
                        <i class="el-icon-arrow-left"></i>
                      </button>
                      <h5 class="integ-view-title">
                        {{ activeIntegrationName }}
                      </h5>
                    </div>
                    <WoocommerceAdd
                      v-if="activeIntegration === 'integWoocommerce'"
                    />
                    <PaymentAdd v-if="activeIntegration === 'integPayphne'" />
                    <PlanGate
                      v-if="activeIntegration === 'integInvoiceApi'"
                      feature="api_access"
                      title="Facturación API disponible desde el plan Escala"
                      description="Conecta tu ERP, tienda en línea o sistema propio para emitir facturas electrónicas automáticamente. Mejora tu plan para generar tu token de integración."
                    >
                      <InvoiceApiTab />
                    </PlanGate>
                    <WhatsappMainComponent
                      v-if="activeIntegration === 'integWhatsapp'"
                    />
                    <MigrationModule
                      v-if="activeIntegration === 'integMigration'"
                      @close="activeIntegration = null"
                    />
                  </div>
                </el-tab-pane>

                <el-tab-pane
                  label="Cuentas bancarias"
                  name="earnings"
                  class="p-4"
                >
                  <b-row>
                    <!-- <b-col xs="12" sm="3" md="3" lg="3">
                      <div class="list-tabs-left">
                        <el-tabs
                          v-model="activeTabsEarnings"
                          :tab-position="tabsPositionLeft"
                          style="height: 200px;"
                          @tab-click="handleTabsEarnings"
                        >
                          <el-tab-pane
                            label="Cuentas de Bancos"
                            name="integBankAccount"
                          ></el-tab-pane>
                          <el-tab-pane
                            label="Formas de Pagos"
                            name="integPayforms"
                          ></el-tab-pane>
                        </el-tabs>
                      </div>
                    </b-col>-->

                    <b-col>
                      <BankAccountList
                        v-show="activeTabsEarnings === 'integBankAccount'"
                      />
                      <!-- <FormsPayCofig
                        v-show="activeTabsEarnings === 'integPayforms'"
                      /> -->
                    </b-col>
                  </b-row>
                </el-tab-pane>
              </el-tabs>
            </div>
          </b-col>
        </b-row>
        <MessageComponent
          title_main="¡Felicidades!"
          :show="businessCreated"
          title="La información de tu empresa fue guardada exitosamente"
          subtitle="Configura tu nueva cuenta de negocio y empieza a administrarlo ¡ahora!"
          btnTitle="Comenzar"
          :routePage="{
            name: 'dashboard'
          }"
        />
      </b-container>
    </section>
    <WrapperBusinessTourComponent />
  </div>
</template>

<script>
import FileUploadComponent from "../../../../components/FileUpload";
import TransitionFadeComponent from "@/components/Transitions/Fade";
import TopBarTitleComponent from "../../../../components/TopBarTitle";
import CategoriesServices from "@/services/CategoriesServices";
import CitiesServices from "@/services/CitiesServices";
import ButtonPrimaryComponent from "../../../../components/ButtonPrimary";
import BusinessStablishmentListComponent from "../components/StablishmentList";
import BusinessStablishmentViewComponent from "../components/StablishmentView";
import SignatureAddComponent from "../../../../billings/components/SignatureAdd";
import DocumentSequenceAddComponent from "../../../../billings/components/DocumentSequenceAdd";
import WrapperBusinessTourComponent from "../components/WrapperTour";
import WoocommerceAdd from "../components/WoocommerceAdd";
import PaymentAdd from "../components/PaymentAdd";
import BankAccountList from "../components/BankAccount/BankAccountList";
//import FormsPayCofig from "../components/FormsPay/FomsPayConfig.vue";

import { mapGetters } from "vuex";
import { PeopleNumbers } from "@/services/PeopleNumbers";
import { bgProfile } from "@/services/resources";
import Countries from "@/services/Countries";
import Validate from "@/assets/validate";
import MessageComponent from "@/modules/dashboard/components/Message";
import ButtonDeleteComponent from "../../../../components/ButtonDelete";
import businessService from "../services/index";
import InvoiceApiTab from "../components/InvoiceApiTab";
import PlanGate from "@/components/PlanGate";
import WhatsappMainComponent from "../../../../configurations/components/preferences/whatsapp/WhatsappMain";
import MigrationModule from "../components/migration/MigrationModule";

export default {
  name: "ProfileBusinessMainPage",
  data: () => ({
    activeTabName: "business",
    activeTabsSignature: "configSignature",
    activeTabsIntegrations: "integWoocommerce",
    activeIntegration: null,
    integrationsList: [
      {
        key: "integWoocommerce",
        name: "WooCommerce",
        desc: "Sincroniza productos y pedidos con tu tienda WooCommerce",
        icon: "el-icon-shopping-bag-2",
        color: "#7f54b3",
        bg: "#f3effb"
      },
      {
        key: "integPayphne",
        name: "Payphone",
        desc: "Recibe pagos con tarjeta de crédito y débito",
        icon: "el-icon-bank-card",
        color: "#1d9e75",
        bg: "#e4fff4"
      },
      {
        key: "integInvoiceApi",
        name: "Facturación API",
        desc: "Conecta sistemas externos para emitir facturas automáticamente",
        icon: "el-icon-document",
        color: "#31355c",
        bg: "#e8ecf5"
      },
      // WhatsApp Business: acceso oculto — la gestión de WhatsApp vive ahora en
      // el módulo de Mensajería (mydessk-next). El componente y su backend siguen
      // intactos (enviar-documento y mensajes masivos lo usan); solo se retira
      // esta tarjeta de Integraciones para evitar confusión con dos WhatsApp.
      {
        key: "integMigration",
        name: "Importar datos",
        desc:
          "Migra tu catálogo, clientes y facturas históricas desde otro sistema",
        icon: "el-icon-upload",
        color: "#3ecfb4",
        bg: "#e1f5ee"
      }
    ],
    activeTabsEarnings: "integBankAccount",
    tabsPositionLeft: "left",
    categories: [],
    peopleNumbers: PeopleNumbers,
    cities: [],
    countries: Countries,
    user: "",
    toogleStablishment: false,
    apiResponse: {
      message: null
    },
    establishmentSelected: null,
    rules: {
      business_name: [Validate.rules.required()],
      business_ruc: [Validate.rules.required()],
      business_email: [
        { ...Validate.rules.required(), ...Validate.rules.email() }
      ],
      business_address: [Validate.rules.required()],
      business_logo: [Validate.rules.required()],
      people_number: [Validate.rules.required("blur")],
      category_id: [Validate.rules.required("blur")],
      social_reason: [Validate.rules.required()]
    },
    businessCreated: false,
    businessStart: false,
    business_logo: null,
    actionForm: null
  }),

  watch: {
    getUser(value) {
      this.user.user_business = value.user_business;
    },

    user(value) {
      this.user = value;
    },

    businessCreated(value) {
      this.businessCreated = value;
    },

    businessStart(value) {
      this.businessStart = value;
    },

    $route() {
      this.$router.go();
    },

    actionForm(value) {
      this.actionForm = value;
    }
  },
  computed: {
    ...mapGetters({
      getUser: "getUser"
    }),

    getUser() {
      return this.$store.getters.getUser;
    },

    activeIntegrationName() {
      const found = this.integrationsList.find(
        i => i.key === this.activeIntegration
      );
      return found ? found.name : "";
    },

    styleProfileImage() {
      return {
        background: `url(${bgProfile}) no-repeat center center`,
        backgroundSize: "cover",
        position: "relative",
        height: "140px"
      };
    },

    getSyncRules() {
      return Validate;
    }
  },

  methods: {
    onFileBase64BusinessLogo(file) {
      this.user.user_business.business_logo = file;
    },

    updateForm() {
      this.actionForm = this.$route.query.action;
      // Si no hay query param pero el usuario ya tiene negocio, modo editar
      if (!this.actionForm && this.getUser && this.getUser.user_business) {
        this.actionForm = "editar";
      }
      if (this.$route.query.action == "nuevo") {
        this.user = {
          user_business: {
            business_id: null,
            business_name: null,
            business_ruc: null,
            business_phone: null,
            business_email: null,
            business_address: null,
            business_logo: "",
            people_number: null,
            category_id: null,
            city_id: null,
            country_code: "EC",
            social_reason: null,
            special_taxpayer_number: null,
            accounting_obligation: false,
            microenterprise_obligation: false,
            popular_business_obligation: false
          }
        };
        this.businessStart = true;
        /*if (this.getUser.businesses.length > 1) {
          this.businessStart = false;
        }*/
        this.$forceUpdate();
      } else {
        this.businessStart = false;
        this.user.user_business = this.getUser.user_business;
        this.user.user_business.accounting_obligation =
          this.user.user_business.accounting_obligation == 1 ? true : false;
        this.user.user_business.microenterprise_obligation =
          this.user.user_business.microenterprise_obligation == 1
            ? true
            : false;
        this.user.user_business.popular_business_obligation =
          this.user.user_business.popular_business_obligation == 1
            ? true
            : false;
      }
    },

    handleTabsSignaturePosition(tab) {
      this.activeTtabsSignature = tab.name;
    },

    handleTabsSignature(tab) {
      this.activeTabsSignature = tab.name;
    },

    handleTabsIntegrations(tab) {
      this.activeTabsIntegrations = tab.name;
    },

    handleTabsEarnings(tab) {
      this.activeTabsEarnings = tab.name;
    },

    handleSaveCurrentTab() {
      switch (this.activeTabName) {
        case "business":
          this.handleSaveBusiness();
          break;
        case "signature":
          this.$root.$emit("negocio:save-signature");
          break;
        case "establishments":
          this.$root.$emit("negocio:save-establishments");
          break;
        default:
          this.handleSaveBusiness();
          break;
      }
    },
    async handleSaveBusiness() {
      const { name, last_name, phone, image } = this.user;

      const {
        id,
        business_name,
        business_id,
        business_ruc,
        business_phone,
        business_email,
        business_address,
        business_logo,
        people_number,
        category_id,
        city_id,
        country_code,
        social_reason,
        special_taxpayer_number,
        accounting_obligation,
        microenterprise_obligation,
        popular_business_obligation
      } = this.user.user_business;

      var data = {
        id,
        name,
        last_name,
        phone,
        image,
        business_name,
        business_id,
        business_ruc,
        business_phone,
        business_email,
        business_address,
        business_logo,
        people_number,
        category_id,
        city_id,
        country_code: country_code || "EC",
        social_reason,
        special_taxpayer_number,
        accounting_obligation,
        microenterprise_obligation,
        popular_business_obligation
      };
      try {
        this.$refs.businessForm.validate(async valid => {
          if (valid) {
            try {
              let response = await this.$store.dispatch("storeBusiness", data);
              const { success } = response.data;
              if (success) {
                if (this.$route.query.action == "nuevo")
                  this.businessCreated = true;
                else {
                  this.$notifications.success({});
                  this.user.user_business.accounting_obligation =
                    this.user.user_business.accounting_obligation == 1
                      ? true
                      : false;
                  this.user.user_business.microenterprise_obligation =
                    this.user.user_business.microenterprise_obligation == 1
                      ? true
                      : false;
                  this.user.user_business.popular_business_obligation =
                    this.user.user_business.popular_business_obligation == 1
                      ? true
                      : false;
                  // this.$refs.businessForm.resetFields();
                }
              }
            } catch (error) {
              return false;
            }
          }
        });
      } catch (error) {
        return false;
      }
    },

    async getCategories() {
      await CategoriesServices.getCategories()
        .then(response => {
          if (response.data.success) this.categories = response.data.categories;
        })
        .catch(() => {});
    },

    async getCities() {
      await CitiesServices.getCities()
        .then(response => {
          if (response.data.success) this.cities = response.data.cities;
        })
        .catch(() => {});
    },

    onStablishmentView(stablishment) {
      this.establishmentSelected = stablishment;
      this.toogleStablishment = !this.toogleStablishment;
    },

    async onConfirmDelete() {
      if (this.getUser.businesses.length > 1) {
        this.$store.dispatch("toggleRequestLoading");
        try {
          let response = await businessService
            .deleteBusiness(this.user.user_business.id)
            .finally(() => {
              this.$store.dispatch("toggleRequestLoading");
            });
          const { success, data } = response.data;
          if (success) {
            this.$notifications.success({});
            this.$refs.businessForm.resetFields();
            this.$store.dispatch("userUpdate", data);
          }
        } catch (error) {
          return false;
        }
      } else {
        this.$notifications.warning({
          message: "No puede eliminar el único negocio registrado."
        });
      }
    }
  },

  components: {
    TransitionFadeComponent,
    TopBarTitleComponent,
    FileUploadComponent,
    ButtonPrimaryComponent,
    BusinessStablishmentListComponent,
    BusinessStablishmentViewComponent,
    SignatureAddComponent,
    DocumentSequenceAddComponent,
    WrapperBusinessTourComponent,
    MessageComponent,
    WoocommerceAdd,
    MigrationModule,
    ButtonDeleteComponent,
    BankAccountList,
    PaymentAdd,
    InvoiceApiTab,
    PlanGate,
    WhatsappMainComponent
    //FormsPayCofig
  },

  beforeMount() {
    this.user = this.getUser;
    if (this.$route.query.action == "nuevo") {
      this.business_logo = null;
    } else {
      this.business_logo = this.user.user_business.business_logo;
    }
  },

  mounted() {
    this.getCategories();
    this.getCities();
    this.updateForm();
    // Leer query param para navegar a tab específico (ej: ?tab=signature)
    if (this.$route.query.tab) {
      this.activeTabName = this.$route.query.tab;
    }
  }
};
</script>

<style scoped lang="scss">
.image {
  display: flex !important;
  justify-content: center;
  align-items: baseline;
  height: 100%;
}

#image-profile {
  width: 100px;
}

#image-business {
  width: 100%;
  height: auto;
}

// ── Integrations card grid ──
$primary: #31355c;
$border: #e4eaf6;
$bg: #f7f8f9;

.integ-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}
.integ-card {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 18px 20px;
  background: #fff;
  border: 1px solid $border;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.15s;

  &:hover {
    border-color: darken($border, 10%);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  }
}
.integ-card-icon {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  i {
    font-size: 20px;
  }
}
.integ-card-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.integ-card-name {
  font-size: 15px;
  font-weight: 600;
  color: $primary;
}
.integ-card-desc {
  font-size: 12px;
  color: #909399;
  line-height: 1.4;
}
.integ-card-arrow {
  font-size: 14px;
  color: #c0c4cc;
  flex-shrink: 0;
}

.integ-view-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
}
.integ-back-btn {
  width: 36px;
  height: 36px;
  border: 1px solid $border;
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: $primary;
  transition: all 0.15s;
  flex-shrink: 0;

  &:hover {
    background: $bg;
    border-color: $primary;
  }
}
.integ-view-title {
  font-size: 18px;
  font-weight: 700;
  color: $primary;
  margin: 0;
}

@media (max-width: 768px) {
  .integ-grid {
    grid-template-columns: 1fr;
  }
}

// ── Signature sub-nav (replicates dir-sidebar style inline) ──
.sig-nav {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-top: 8px;
}

.sig-nav-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border-radius: 8px;
  border-left: 3px solid transparent;
  color: #606266;
  font-size: 13px;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.15s;

  &:hover {
    background: #f4f6fb;
    color: #3ecfb4;
    text-decoration: none;
  }

  &.active {
    background: #f0fdf9;
    color: #3ecfb4;
    border-left-color: #3ecfb4;
    font-weight: 600;
  }
}

.sig-nav-item-icon {
  font-size: 16px;
  flex-shrink: 0;
}
</style>
